import type { DiaryKeyT } from "@/types/database/diaries";

import PainExplainer from "./PainExplainer";
interface Props {
	diaryType: DiaryKeyT;
}
const ExplainerSwitch = ({ diaryType }: Props) => {
	switch (diaryType) {
		case "PAIN":
			return <PainExplainer />;
		default:
			return <PainExplainer />;
	}
};

export default ExplainerSwitch;
